import ModalComponent from '../../../components/ModalComponent';
import DropdownComponent from '../../../components/DropdownComponent';
import { ReactNode, useEffect, useState } from 'react';
import CigamEditionForm from './CigamEditionForm';
import MoniEditionForm from './MoniEditionForm';
import SurgardEditionForm from './SurgardEditionForm';
import SigmaEditionForm from './SigmaEditionForm';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import DefenseEditionForm from './DefenseEditionForm';
import WebhookEditionForm from './WebhookEditionForm';
import {
  IIntegrationProps,
  IntegrationDiscriminator,
} from '../../../services/IntegrationService/types';
import DefenseBridgeEditionForm from './DefenseBridgeEditionForm';
import TuyaEditionForm from './TuyaEditionForm';
import TotvsEditionForm from './TotvsEditionForm';
import { t } from 'i18next';
import ClassAppEditionForm from './ClassAppEditionFormInput';
import GvdasaEditionForm from './GvdasaEdtionForm';
import ActiveSoftEditionForm from './ActiveSoftEditForm';
import SophiaEditionForm from './SophiaEditForm';
import ClipEscolaEditForm from './ClipEscolaEditForm';
import SmtpEditForm from './SmtpEditForm';
import TotvsIENHEditionForm from './TotvsIENHEditionForm';
import MoovsecEditionForm from './MoovsecEditionForm';

interface IntegrationEditModalProps {
  isOpen: boolean;
  handleClose: () => void;
  integrationSelected?: IIntegrationProps;
  renderIconByIntegrationType: (type: IntegrationDiscriminator) => ReactNode;
}

type IntegrationType =
  | 'CIGAM'
  | 'DEFENSE'
  | 'MONI'
  | 'SIGMA'
  | 'SURGARD'
  | 'WEBHOOK'
  | 'DEFENSE_BRIDGE'
  | 'TUYA'
  | 'TOTVS'
  | 'CLASSAPP'
  | 'GVDASA'
  | 'ACTIVESOFT'
  | 'CLIPESCOLA'
  | 'SMTP'
  | 'SOPHIA'
  | 'TOTVSIENH'
  | 'MOOVSEC';

const IntegrationEditModal = ({
  isOpen,
  renderIconByIntegrationType,
  handleClose,
  integrationSelected,
}: IntegrationEditModalProps) => {
  const [selectedIntegrationType, setSelectedIntegrationType] =
    useState<IntegrationType>();
  const [selectedItemIdToEdit, setSelectedItemIdToEdit] = useState<number>();

  const integrationsOptions = [
    {
      label: 'Cigam',
      value: 'CIGAM',
      icon: renderIconByIntegrationType('CigamEntity'),
    },
    {
      label: 'Defense',
      value: 'DEFENSE',
      icon: renderIconByIntegrationType('DefenseEntity'),
    },
    {
      label: 'Moni',
      value: 'MONI',
      icon: renderIconByIntegrationType('MoniEntity'),
    },
    {
      label: 'Sigma',
      value: 'SIGMA',
      icon: renderIconByIntegrationType('SigmaEntity'),
    },
    {
      label: 'Surgard',
      value: 'SURGARD',
      icon: renderIconByIntegrationType('SurgardEntity'),
    },
    {
      label: 'Webhook',
      value: 'WEBHOOK',
      icon: renderIconByIntegrationType('WebhookEntity'),
    },
    {
      label: 'Defense Bridge',
      value: 'DEFENSE_BRIDGE',
      icon: renderIconByIntegrationType('DefenseBridgeEntity'),
    },
    {
      label: 'Tuya',
      value: 'TUYA',
      icon: renderIconByIntegrationType('TuyaEntity'),
    },
    {
      label: 'Totvs',
      value: 'TOTVS',
      icon: renderIconByIntegrationType('TotvsEntity'),
    },
    {
      label: 'ClassApp',
      value: 'CLASSAPP',
      icon: renderIconByIntegrationType('ClassAppEntity'),
    },
    {
      label: 'Gvdasa',
      value: 'GVDASA',
      icon: renderIconByIntegrationType('GvdasaEntity'),
    },
    {
      label: 'ActiveSoft',
      value: 'ACTIVESOFT',
      icon: renderIconByIntegrationType('ActiveSoftEntity'),
    },
    {
      label: 'ClipEscola',
      value: 'CLIPESCOLA',
      icon: renderIconByIntegrationType('ClipEscolaEntity'),
    },
    {
      label: 'Smtp',
      value: 'SMTP',
      icon: renderIconByIntegrationType('SmtpEntity'),
    },
    {
      label: 'Sophia',
      value: 'SOPHIA',
      icon: renderIconByIntegrationType('SophiaEntity'),
    },
    {
      label: 'TotvsIENH',
      value: 'TOTVSIENH',
      icon: renderIconByIntegrationType('TotvsIENHEntity'),
    },
    {
      label: 'Moovsec',
      value: 'MOOVSEC',
      icon: renderIconByIntegrationType('MoovsecEntity'),
    },
  ];

  const renderIntegrationFormBySelection = () => {
    switch (selectedIntegrationType) {
      case 'CIGAM':
        return (
          <CigamEditionForm
            handleSaveForm={handleCloseForm}
            cigamIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'MONI':
        return (
          <MoniEditionForm
            handleSaveForm={handleCloseForm}
            moniIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'SIGMA':
        return (
          <SigmaEditionForm
            handleSaveForm={handleCloseForm}
            sigmaIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'SURGARD':
        return (
          <SurgardEditionForm
            handleSaveForm={handleCloseForm}
            surgardIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'WEBHOOK':
        return (
          <WebhookEditionForm
            handleSaveForm={handleCloseForm}
            webhookIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'DEFENSE':
        return (
          <DefenseEditionForm
            handleSaveForm={handleCloseForm}
            defenseIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'DEFENSE_BRIDGE':
        return (
          <DefenseBridgeEditionForm
            handleSaveForm={handleCloseForm}
            defenseBridgeIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'CLASSAPP':
        return (
          <ClassAppEditionForm
            handleSaveForm={handleCloseForm}
            totvsIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'GVDASA':
        return (
          <GvdasaEditionForm
            handleSaveForm={handleCloseForm}
            totvsIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'TUYA':
        return (
          <TuyaEditionForm
            handleSaveForm={handleCloseForm}
            tuyaIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'TOTVS':
        return (
          <TotvsEditionForm
            handleSaveForm={handleCloseForm}
            totvsIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'ACTIVESOFT':
        return (
          <ActiveSoftEditionForm
            handleSaveForm={handleCloseForm}
            totvsIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'CLIPESCOLA':
        return (
          <ClipEscolaEditForm
            handleSaveForm={handleCloseForm}
            totvsIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'SOPHIA':
        return (
          <SophiaEditionForm
            handleSaveForm={handleCloseForm}
            totvsIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'SMTP':
        return (
          <SmtpEditForm
            handleSaveForm={handleCloseForm}
            smtpIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'TOTVSIENH':
        return (
          <TotvsIENHEditionForm
            handleSaveForm={handleCloseForm}
            totvsIdToUpdate={selectedItemIdToEdit}
          />
        );
      case 'MOOVSEC':
        return (
          <MoovsecEditionForm
            handleSaveForm={handleCloseForm}
            moovsecIdToUpdate={selectedItemIdToEdit}
          />
        );
    }
    return <></>;
  };

  const handleCloseForm = () => {
    setSelectedItemIdToEdit(undefined);
    setSelectedIntegrationType(undefined);
    handleClose();
  };

  useEffect(() => {
    if (integrationSelected && integrationSelected.discriminator) {
      switch (integrationSelected.discriminator) {
        case 'CigamEntity':
          setSelectedIntegrationType('CIGAM');
          break;
        case 'MoniEntity':
          setSelectedIntegrationType('MONI');
          break;
        case 'SurgardEntity':
          setSelectedIntegrationType('SURGARD');
          break;
        case 'WebhookEntity':
          setSelectedIntegrationType('WEBHOOK');
          break;
        case 'DefenseEntity':
          setSelectedIntegrationType('DEFENSE');
          break;
        case 'SigmaEntity':
          setSelectedIntegrationType('SIGMA');
          break;
        case 'DefenseBridgeEntity':
          setSelectedIntegrationType('DEFENSE_BRIDGE');
          break;
        case 'TuyaEntity':
          setSelectedIntegrationType('TUYA');
          break;
        case 'ActiveSoftEntity':
          setSelectedIntegrationType('ACTIVESOFT');
          break;
        case 'ClipEscolaEntity':
          setSelectedIntegrationType('CLIPESCOLA');
          break;
        case 'SmtpEntity':
          setSelectedIntegrationType('SMTP');
          break;
        case 'GvdasaEntity':
          setSelectedIntegrationType('GVDASA');
          break;
        case 'ClassAppEntity':
          setSelectedIntegrationType('CLASSAPP');
          break;
        case 'SophiaEntity':
          setSelectedIntegrationType('SOPHIA');
          break;
        case 'TotvsIENHEntity':
          setSelectedIntegrationType('TOTVSIENH');
          break;
        case 'MoovsecEntity':
          setSelectedIntegrationType('MOOVSEC');
          break;
      }
      setSelectedItemIdToEdit(integrationSelected.id);
    }
  }, [integrationSelected]);

  return (
    <ModalComponent
      title={
        integrationSelected
          ? t('integrationsPage.editIntegration')
          : t('integrationsPage.newIntegration')
      }
      isOpen={isOpen}
      onClose={() => handleCloseForm()}
    >
      <DropdownComponent
        label={t('integrationsPage.typeIntegration')}
        value={selectedIntegrationType}
        optionLabel={'label'}
        optionIcon={'icon'}
        optionValue={'value'}
        options={integrationsOptions}
        onChange={setSelectedIntegrationType}
        disabled={Boolean(integrationSelected)}
      />
      {selectedIntegrationType && (
        <>
          <Divider sx={{ mt: 2 }} variant="middle" color={'#b7b7b7'} />
          <Box sx={{ mt: 4 }}>{renderIntegrationFormBySelection()}</Box>
        </>
      )}
    </ModalComponent>
  );
};

export default IntegrationEditModal;
